import { Constants, Utils } from "@zanichelli/myz-react-utils";

import { call, put, select, takeEvery } from "redux-saga/effects";

import { canUseMyzToken, wotdFormData } from "../selectors";
import { alertsAddApiAlert } from "../Alerts/actions";
import { WotdFormData } from "../../../beans/api";
import { wotdDataMapping } from "../../../utils/mapping";
import { post, update, remove } from "../../../utils/requestV3MyzToken";

import {
  IWotdFormDataRequest,
  IWotdFormDataManage,
  WotdFormDataAction,
  WotdFormDataActionEnum,
  wotdFormDataFail,
  wotdFormDataSuccess,
} from "./actions";

export function* wotdFormDataRequestSaga(action: IWotdFormDataRequest) {
  const useToken: boolean = yield select(canUseMyzToken);
  const wotdData: WotdFormData = yield select(wotdFormData);
  const requestURL = useToken
    ? "wotd/subscriptions/logged"
    : "wotd/subscriptions";

  const wotdMappedData = wotdDataMapping(wotdData, action.email);

  const requestOpt = {
    headers: useToken
      ? { [Constants.ENV.MYZ_TOKEN_KEY]: Utils.getMyzTokenCookie() }
      : {},
    body: wotdMappedData,
  };

  try {
    yield call(post, requestURL, requestOpt);
    yield put(wotdFormDataSuccess());
  } catch (err) {
    yield put(wotdFormDataFail(err));
    yield put(alertsAddApiAlert());
  }
}

export function* wotdFormDataManageSaga(action: IWotdFormDataManage) {
  try {
    const useToken: boolean = yield select(canUseMyzToken);

    if (!useToken && !action.hash) throw new Error("Invalid request");

    const wotdData: WotdFormData = yield select(wotdFormData);

    const requestURL = useToken
      ? "wotd/subscriptions/logged"
      : `wotd/subscriptions/${action.hash}`;

    const requestOpt = {
      headers: useToken
        ? { [Constants.ENV.MYZ_TOKEN_KEY]: Utils.getMyzTokenCookie() }
        : {},
    };

    const isUpdate =
      Object.values(wotdData.words).filter((item: boolean | undefined) => item)
        .length > 0;

    if (isUpdate) {
      const wotdMappedData = wotdDataMapping(wotdData);
      yield call(update, requestURL, wotdMappedData, requestOpt);
    } else {
      yield call(remove, requestURL, {
        ...requestOpt,
        data: wotdData.personalData,
      });
    }
    yield put(wotdFormDataSuccess());
  } catch (err) {
    yield put(wotdFormDataFail(err));
  }
}

export function* sagas() {
  yield takeEvery(WotdFormDataActionEnum.REQUEST, wotdFormDataRequestSaga);
  yield takeEvery(WotdFormDataActionEnum.MANAGE, wotdFormDataManageSaga);
}

export interface IWotdFormDataState {
  loading: boolean;
  loaded: null | boolean;
  wotdFormData: WotdFormData;
  error: null | Error;
}

const initialState: IWotdFormDataState = {
  loading: false,
  loaded: null,
  wotdFormData: {
    words: {
      wordZingarelli: true,
      wordRagazzini: true,
      wordBoch: true,
      wordGkte: true,
      wordSpagnolo: true,
    },
    personalData: {
      privacy: false,
      copyright: false,
      termsOfUse: false,
    },
  },
  error: null,
};

const WotdFormDataState = (
  state: IWotdFormDataState = initialState,
  action: WotdFormDataAction,
): IWotdFormDataState => {
  switch (action.type) {
    case WotdFormDataActionEnum.REQUEST:
    case WotdFormDataActionEnum.MANAGE:
      return {
        ...state,
        loading: true,
      };
    case WotdFormDataActionEnum.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case WotdFormDataActionEnum.FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.err,
      };
    case WotdFormDataActionEnum.SET:
      if (Object.keys(action.checkboxes)[0] in state.wotdFormData.words) {
        return {
          ...state,
          wotdFormData: {
            ...state.wotdFormData,
            words: { ...state.wotdFormData.words, ...action.checkboxes },
          },
        };
      }
      return {
        ...state,
        wotdFormData: {
          ...state.wotdFormData,
          personalData: {
            ...state.wotdFormData.personalData,
            ...action.checkboxes,
          },
        },
      };

    default:
      return state;
  }
};
export default WotdFormDataState;
